module.exports = __webpack_public_path__ + "img/facebook-profile-instruction-1.afdaa455.png";